import React from 'react'

/* The code is defining a functional component called `HeaderButton` in JavaScript React. */
function HeaderButton({ onClick, isSelected, children }) {
    return (
        <button
            className={
                "whitespace-nowrap text-[11pt] leading-[14pt] lg:text-[14px]   rounded-3xl  px-4 py-1.5   block lg:leading-[16px] " +
                (isSelected
                    ? "text-[#FFFFFF] font-sans_medium_body bg-[#BC8B20]"
                    : "text-[#AAAAAA] font-sans_book_body bg-[#EEEEEE]")
            }
            onClick={onClick}>
            {children}
        </button>
    )
}

export default HeaderButton